<template>
    <v-col cols="12" md="6" class="pr-6">
        <v-row>
            <v-col cols="12" align="start" class="ml-4 color-text text-h5">
                {{ $t('profile.your_profile') }}
            </v-col>
            <v-col cols="12" justify="center" align="center">
                <v-card
                    class="px-2 px-lg-4 py-0 py-lg-4"
                    elevation="12"
                    :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?450:280"
                >
                    <v-row align="center" justify="center">
                        <v-col cols="6" lg="4" order="2" order-lg="1" class="pa-0 text-h5 font-weight-regular">
                            <v-img src="/img/user/points.svg" max-height="150" max-width="150">
                                <v-row class="mt-12 pt-2 text-h4 color-primary" justify="center">
                                    {{ userData.points }}
                                </v-row>
                            </v-img>
                            <p class="text-center color-text">
                                {{ userData.points }}
                                {{ $t('profile.points') }}
                            </p>
                        </v-col>
                        <v-col cols="12" lg="4" order="1" order-lg="2" class="pa-0 text-h5 font-weight-regular">
                            <v-img src="/img/user/beecoin-2.svg" max-height="200" max-width="200"></v-img>
                            <p class="text-center color-text">
                                {{ userData.coins }}
                                Beecoins
                            </p>
                        </v-col>
                        <v-col cols="6" lg="4" order="3" class="pa-0 text-h5 font-weight-regular color-primary">
                            <vue-ellipse-progress
                                :progress="userData.advancePercent"
                                :size="120"
                                :legend="false"
                                emptyColor="#816AD6"
                                :color="gradient"
                                thickness="10"
                                emptyThickness="10"
                                dot="25 #FFB600"
                                class="text-h5"
                            >
                            <div slot="legend-caption" class="text-h4">
                                {{ userData.level }}
                            </div>
                            </vue-ellipse-progress>
                            <p class="text-center color-text">
                                {{ $t('profile.level') }} {{ userData.level }}
                            </p>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            userData: (state) => state.userData
        }),
    },
    data() {
        return {
            gradient: {
                radial: false,
                colors: [
                    {
                        color: '#FFDA00',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#FFC400',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.color-primary {
    color: #816AD6;
}
.color-text {
    color: #4A3216;
}
.v-card {
    border-radius: 20px;
}
</style>